import React from 'react';
import './elimina-account.scss';
import {Link, useNavigate} from 'react-router-dom';
import {ROUTES} from '../../constant/constant';
import UserService from '../../service/user-service';
import PersistenceService from '../../service/persistence-service';

function EliminaAccount() {

  const navigateTo = useNavigate();
  const deleteAccount = async () => {
    const response = await UserService.deleteConsents();

    if (response.code === 0) {
      navigateTo(ROUTES.MP_DELETED);
      PersistenceService.reset();
    } else {
      navigateTo(response.description ? `${ROUTES.GENERIC_ERROR}/${response.description}` : ROUTES.GENERIC_ERROR);
    }
  }

  return (
    <div className="EliminaAccount">
      <button className="confirm-btn" onClick={deleteAccount}>Elimina account</button>
      <Link to={ROUTES.MY_PROFILE} className="btn-link"><button className="link-btn">Annulla</button></Link>
    </div>
  );
}

export default EliminaAccount;
